import { Document, Page, Image, Text, View } from "@react-pdf/renderer";
import moment from "moment";
import React from "react";
import { styles } from "..";
import DCAFImg from "../../../assets/img/DCAF.png";
const DCAF = ({ printData, printedName }) => {
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));

  const patinetInfo = printData?.patient;

  const coveragePersonal = printData?.coverage_info;
  const payerPersonal = printData?.payer_response;
  const visitTimeDate = moment(payerPersonal?.requestat).format(
    "DD-MM-YYYY , hh:MM A"
  );
  return (
    <Document>
      <Page size="A3" style={styles.page}>
        <Text style={styles.heading}>dcaf 2.0</Text>
        <View style={styles.flexRow}>
          <View style={styles.cardStyle}>
            <Text style={styles.title}>
              To be completed & ID verified by the reception/nurse:
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Provider Name: </Text>
              <Text style={styles.s1textvalue}>
                {selectedBranch?.branch_name || "-"}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Insurance Company Name: </Text>
              <Text style={styles.s1textvalue}>
                {printData?.insurance_name || "-"}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>TPA Company Name: </Text>
              <Text style={styles.s1textvalue}>{"-"}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Patient File Number: </Text>
              <Text style={styles.s1textvalue}>{patinetInfo?.patient_mrn}</Text>
            </Text>
            <View style={styles.flexRow}>
              <Text style={styles.checkItem}>
                Single {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Married {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Plan Type {"(  "}
                {")"}
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date of visit: </Text>
              <Text style={styles.s1textvalue}>{visitTimeDate}</Text>
            </Text>
            <View style={styles.flexRow}>
              <Text style={styles.checkItem}>
                New visit {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Follow Up {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Refill {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Walk In {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Referral {"(  "}
                {")"}
              </Text>
            </View>
          </View>
          <View style={styles.cardStyle}>
            <Text style={styles.title}>
              Print/Fill in clear letters or Emboss Card:
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Insurance Name: </Text>
              <Text style={styles.s1textvalue}>
                {`${patinetInfo?.patient_firstname || ""} ${
                  patinetInfo?.patient_familyname
                }`}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>National ID / Iqama : </Text>
              <Text style={styles.s1textvalue}>
                {patinetInfo?.patient_nationalid}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>ID. Card No. : </Text>
              <Text style={styles.s1textvalue}>
                {coveragePersonal?.memberid}
              </Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Sex : </Text>
                <Text style={styles.s1textvalue}>{patinetInfo?.gender}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>DOB : </Text>
                <Text style={styles.s1textvalue}>
                  {patinetInfo?.patient_dob}
                </Text>
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Policy Holder : </Text>
              <Text style={styles.s1textvalue}>
                {patinetInfo?.sponsor_name}
              </Text>
            </Text>

            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Policy No. : </Text>
                <Text style={styles.s1textvalue}>
                  {patinetInfo?.sponsor_no}
                </Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Expiry Date : </Text>
                <Text style={styles.s1textvalue}>
                  {payerPersonal?.serviceto}
                </Text>
              </Text>
            </View>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Class : </Text>
                <Text style={styles.s1textvalue}>
                  {coveragePersonal?.class}
                </Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Status : </Text>
                <Text style={styles.s1textvalue}>
                  {printData?.eligibility_status || "-"}
                </Text>
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Eligibility Ref. NO : </Text>
              <Text style={styles.s1textvalue}>
                {payerPersonal?.reference_no || "-"}
              </Text>
            </Text>
          </View>
        </View>
        <View style={[styles.card, { paddingBottom: "20px" }]}>
          <View style={styles.flexRow}>
            <View style={styles.cardStyle1}>
              <Text style={styles.title}>To be Completed by the Dentist:</Text>
              <Text style={styles.s1textLabel}>Duration of Illness:</Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>
                  Chief Complaints and Main Symptoms:{" "}
                </Text>
                <Text style={styles.s1textvalue}> {"."?.repeat(75)}</Text>
              </Text>
              <Text>{"."?.repeat(200)}</Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Siginficant Signs: </Text>
                <Text style={styles.s1textvalue}> {"."?.repeat(75)}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.label}>Diagnosis (ICD10): </Text>
                <Text style={styles.s1textvalue}> {"."?.repeat(75)}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Primary: </Text>
                <Text style={styles.s1textvalue}> {"."?.repeat(75)}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Secondary: </Text>
                <Text style={styles.s1textvalue}> {"."?.repeat(75)}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Other Conditions: </Text>
                <Text style={styles.s1textvalue}> {"."?.repeat(75)}</Text>
              </Text>
              <Text style={styles.commentLine} />
              <Text style={[styles.label, styles.mt3]}>
                Please tick (✓) where appropriate:{" "}
              </Text>
              <View style={styles.flexRow}>
                <Text style={styles.dottedLine}>
                  <Text style={styles.s1textLabel}>
                    Regular Dental Treatment:{" "}
                  </Text>
                  <Text style={styles.s1textvalue}> ({"  "})</Text>
                </Text>
                <Text style={styles.dottedLine}>
                  <Text style={styles.s1textLabel}>Dental Cleaning: </Text>
                  <Text style={styles.s1textvalue}> ({"  "})</Text>
                </Text>
              </View>
              <View style={styles.flexRow}>
                <Text style={styles.dottedLine}>
                  <Text style={styles.s1textLabel}>
                    Trauma Treatment Specify: RTA{" "}
                  </Text>
                  <Text style={styles.s1textvalue}> ({"  "})</Text>
                </Text>
                <Text style={styles.dottedLine}>
                  <Text style={styles.s1textLabel}>Work Related: </Text>
                  <Text style={styles.s1textvalue}> ({"  "})</Text>
                </Text>
              </View>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Other : </Text>
                <Text style={styles.s1textvalue}> {"."?.repeat(75)}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Hwo : </Text>
                <Text style={styles.s1textvalue}> {"."?.repeat(75)}</Text>
              </Text>
              <View style={styles.flexRow}>
                <Text style={styles.dottedLine}>
                  <Text style={styles.s1textLabel}>When : </Text>
                  <Text style={styles.s1textvalue}> {"."?.repeat(45)}</Text>
                </Text>
                <Text style={styles.dottedLine}>
                  <Text style={styles.s1textLabel}>Where : </Text>
                  <Text style={styles.s1textvalue}> {"."?.repeat(45)}</Text>
                </Text>
              </View>
            </View>

            <View style={[styles.cardStyle2, { marginLeft: "50px" }]}>
              <Image source={DCAFImg} style={{ width: "200px" }} />
            </View>
          </View>
          <Text style={[styles.title, styles.cardDetails]}>
            Specify the recommended procedures using the tooth number as shown
            on the teeth map above:
          </Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text
                style={[styles.tableCell, { borderTop: "0.7px solid #999" }]}
              >
                Code
              </Text>
              <Text
                style={[
                  styles.tableCell,
                  styles.descriptionCell1,
                  { borderTop: "0.7px solid #999" },
                ]}
              >
                Description
              </Text>
              <Text
                style={[styles.tableCell, { borderTop: "0.7px solid #999" }]}
              >
                Tooth No.
              </Text>
              <Text
                style={[
                  styles.tableCell,
                  styles.lastTableCell,
                  { borderTop: "0.7px solid #999" },
                ]}
              >
                Cost
              </Text>
            </View>
            {[0, 1, 2]?.map((_, index) => (
              <View style={styles.tableRow} key={index}>
                <Text style={styles.tableCell}></Text>
                <Text
                  style={[styles.tableCell, styles.descriptionCell1]}
                ></Text>
                <Text style={[styles.tableCell, styles.s1textvalue]}>
                  {index === 2 ? "Total" : "    "}
                </Text>
                <Text style={[styles.tableCell, styles.lastTableCell]}></Text>
              </View>
            ))}
          </View>
          <View style={[styles.flexRow]}>
            <Text style={[styles.s1textLabel, styles.text, styles.mt3]}>
              Providers Approval/Coding Staff must review/code the recommended
              service(s) and allocate cost and complete the following:
            </Text>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Completed / Coded By: </Text>
              <Text style={styles.s1textvalue}> {"."?.repeat(30)}</Text>
            </Text>

            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Signature: </Text>
              <Text style={styles.s1textvalue}> {"."?.repeat(30)}</Text>
            </Text>

            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date: </Text>
              <Text style={styles.s1textvalue}>
                {" "}
                {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
              </Text>
            </Text>
          </View>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text
                style={[
                  styles.tableCell1,
                  styles.descriptionCell1,
                  { borderTop: "0.7px solid #999" },
                ]}
              >
                Medication Name (Generic Name)
              </Text>

              <Text
                style={[styles.tableCell1, { borderTop: "0.7px solid #999" }]}
              >
                Type
              </Text>
              <Text
                style={[
                  styles.tableCell1,
                  styles.lastTableCell,
                  { borderTop: "0.7px solid #999" },
                ]}
              >
                Quantity
              </Text>
            </View>
            {[0, 1, 2, 3, 4]?.map((_, index) => (
              <View style={styles.tableRow} key={index}>
                <Text
                  style={[styles.tableCell1, styles.descriptionCell1]}
                ></Text>
                <Text style={styles.tableCell1}></Text>
                <Text style={[styles.tableCell1, styles.lastTableCell]}></Text>
              </View>
            ))}
          </View>
        </View>

        <View style={[styles.flexRow]}>
          <View style={styles.cardStyle}>
            <Text style={styles.s1textvalue}>
              I hereby certify that ALL information mentioned are correct and
              that the medical services shown on this form were medically
              indicated and necessary for the management of this case.
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Physician: </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(70)}</Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Signature: </Text>
                <Text style={styles.s1textvalue}>{"."?.repeat(40)}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Date: </Text>
                <Text style={styles.s1textvalue}>
                  {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
                </Text>
              </Text>
            </View>
          </View>
          <View style={styles.cardStyle}>
            <Text style={styles.s1textvalue}>
              I hereby certify that ALL statements and information provided
              concerning patient identification and the present illness or
              injury are TRUE.
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Name (and relationship if guardian):{" "}
              </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(50)}</Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Signature(*) </Text>
                <Text style={styles.s1textvalue}></Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Date: </Text>
                <Text style={styles.s1textvalue}>
                  {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
                </Text>
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.card}>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                For Insurance Company use Only
              </Text>
              <Text style={styles.s1textvalue}>
                Approved ( ) Not Approved ( )
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval No: {"  "}</Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(15)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval validity </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
          </View>
          <Text style={styles.s1textvalue}>
            Comments (include approved days/services if different from the
            requested)
          </Text>
          <Text style={[styles.s1textvalue, { paddingTop: 5 }]}>
            {"."?.repeat(100)}
          </Text>
          <View style={styles.flexRow}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Approved/Disapproved By {"  "}
              </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Signature {"  "}</Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date: </Text>
              <Text style={styles.s1textvalue}>
                {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
              </Text>
            </Text>
          </View>
        </View>
        <Text style={styles.s1textLabel}>
          (*) this is applicable only in case of manual UCAF{" "}
        </Text>

        <Text style={styles.createdBy} fixed>
          {`Printed by: | ${printedName || ""} ${moment().format("lll")}`}
        </Text>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber || ""} of ${totalPages || ""}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default DCAF;
